import { getSearchId, searchKey } from '@util/searchAttribution';
import { usePathname, useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

/** The id of the search on screen; see searchAttribution.ts. */
export default function useSearchId() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const key = searchKey(pathname, searchParams);
  return useMemo(() => getSearchId(key), [key]);
}
